import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@src/lib/ui/DropdownMenu";
import { AiOrgContextFragment } from "@src/features/settings/hooks/useBranding.generated";
import { Button } from "@src/lib/ui/Button";
import CopyrightOutlineIcon from "@src/lib/icons/18px/copyright-outline";

const ComposerBrandSelector = ({
  brandSelectOptions,
  onSelectValueChange,
  selectedBrandItem,
}: {
  brandSelectOptions: BrandSelectOption[];
  onSelectValueChange: (value: string) => void;
  selectedBrandItem?: BrandSelectOption;
}): React.ReactElement => {
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="xs" className="h-[28px]">
            {selectedBrandItem?.logoUrl ? (
              <div
                className="size-4 rounded-full"
                style={{
                  background: `url(${selectedBrandItem.logoUrl}) lightgray 50% / cover no-repeat`,
                }}
              />
            ) : (
              <CopyrightOutlineIcon className="mr-1 !size-4 text-muted-foreground" />
            )}
            {selectedBrandItem?.name}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="min-w-[200px]">
          {brandSelectOptions.map((option) => (
            <DropdownMenuItem
              key={option.aiOrgContextId}
              onSelect={() => onSelectValueChange(option.aiOrgContextId)}
            >
              <BrandSelectOptionItem brandSelectOption={option} />
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
export default ComposerBrandSelector;

export const BrandSelectOptionItem = ({
  brandSelectOption,
}: {
  brandSelectOption: BrandSelectOption;
}): React.ReactElement => {
  return (
    <div className="flex flex-1 items-center gap-2">
      <div style={{ borderRadius: "6.857px" }}>
        {brandSelectOption.logoUrl ? (
          <div
            style={{
              height: 24,
              width: 24,
              background: `url(${brandSelectOption.logoUrl}) lightgray 50% / cover no-repeat`,
              borderRadius: 24,
            }}
          />
        ) : (
          <CopyrightOutlineIcon className="size-6 text-gray-10" />
        )}
      </div>
      <div>{brandSelectOption.name}</div>
    </div>
  );
};

export type BrandSelectOption = {
  name: string;
  aiOrgContextId: string;
  logoUrl: string;
  aiOrgContext: AiOrgContextFragment;
  brandDetailsId: string;
};
